export const giftCodeDeliveryMethods = {
  '1': 'Email',
  '2': 'Text Message',
  '3': 'Print At Home',
  '4': 'Post Office'
};

export const getAvailableDeliveryMethods = (isEmailEnabled, isSMSEnabled) => {
  const giftCodeDeliveryMethods = {
    '4': 'Post Office'
  };

  if (isEmailEnabled) {
    giftCodeDeliveryMethods['1'] = 'Email';
    giftCodeDeliveryMethods['3'] = 'Print At Home';
  }

  if (isSMSEnabled) {
    giftCodeDeliveryMethods['2'] = 'Text Message';
  }

  return giftCodeDeliveryMethods;
};

export const giftCardStatus = {
  '1': 'Active',
  '2': 'Inactive',
  '3': 'Pending',
  '4': 'Used',
  '5': 'Expired',
  '6': 'Cancelled'
};

export const giftCardHistoryActions = {
  '1': 'Created',
  '2': 'Updated',
  '3': 'Sent',
  '4': 'Spent',
  '5': 'Expired',
  '6': 'Redeemed',
  '7': 'Refunded',
  '8': 'Reverted'
};
